import toast from 'react-hot-toast'

import { useMutation } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'
import type { UpdateLoadGLCodeRequest } from '@fv/models'

import { useUpdateCachedLoad } from '@/hooks/shipments'
import { shipperFetch } from '@/utils/shipperFetch'

const putEditGLCode =
  (loadId: string) => async (body: UpdateLoadGLCodeRequest) =>
    await shipperFetch<FullShipment>(`/shipments/${loadId}/gl-code`, {
      body,
      method: 'PUT',
    })

export function useEditGLCode(loadId: string) {
  const updateCachedLoad = useUpdateCachedLoad()

  const mutation = useMutation(putEditGLCode(loadId), {
    onError: () => {
      toast.error('Unable to update GL Code')
    },

    onSuccess: updatedLoad => {
      updateCachedLoad({ updatedLoad })
      toast.success('GL Code updated successfully')
    },
  })
  return mutation
}
